module.exports = __webpack_public_path__ + "img/TXT-SOCIAL-AUDIOMACK.8c95c27e.png";